<template>
  <div class="home-box">
    <home-convas></home-convas>
    <home-list class="site-content" :articles="articles"></home-list>
    <page-footer></page-footer>
  </div>
</template>
<script>
import HomeConvas from '@/components/convas/convas'
import HomeList from './components/list'
import PageFooter from '@/components/footer/footer'
import avatar from '../../assets/images/me.jpeg'
import { setMeta } from '../../utils/siteMeta'
export default {
  name: 'HomePage',
  components: {
    HomeConvas,
    HomeList,
    PageFooter
  },
  data () {
    return {
      articles: []
    }
  },
  methods: {
    getArticles () {
      this.$axios.get('/api/article/published')
        .then(res => { this.articles = res.data })
    }
  },
  mounted () {
    this.getArticles()
    setMeta("SEVEN's blog", "SEVEN's blog - https://seven.geekfun.club/", avatar, 'https://seven.geekfun.club/article')
  }
}
</script>
<style lang="stylus" scoped>
.home-box
  display: flex
  min-height: 100vh
  flex-direction: column
  .site-content
    flex: 1
</style>
